import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import React, { useState, useEffect, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEqual, debounce } from 'lodash';
import { validate, mergeStyles, GlobalContext } from 'wix-rich-content-common';
import { g as getIcon, f as fileStyles, E as ErrorIcon, L as LoaderIcon, R as ReadyIcon, D as DownloadIcon } from './file-upload-viewer2.js';
import pluginFileUploadSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-file-upload.schema.json';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import classnames from 'classnames';
import { FILE_UPLOAD_TYPE } from './viewer-loadable.js';
import '@loadable/component';
import 'ricos-types';

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var PDFViewSDKClient = /*#__PURE__*/function () {
  function PDFViewSDKClient(scope) {
    var _this = this;
    this.window = scope;
    this.readyPromise = new Promise(function (resolve) {
      if (_this.window.AdobeDC) {
        resolve();
      } else {
        _this.window.document.addEventListener("adobe_dc_view_sdk.ready", function () {
          resolve();
        });
      }
    });
  }
  var _proto = PDFViewSDKClient.prototype;
  _proto.ready = function ready() {
    return this.readyPromise;
  };
  _proto.previewFileWithURL = function previewFileWithURL(config, fileData, viewerConfig) {
    var _this2 = this;
    var url = fileData.url,
      fileName = fileData.fileName;
    this.adobeDCView = new this.window.AdobeDC.View(config);
    return new Promise(function (resolve) {
      _this2.adobeDCView.previewFile({
        content: {
          location: {
            url: url
          }
        },
        metaData: {
          fileName: fileName
        }
      }, __spreadProps(__spreadValues({}, viewerConfig), {
        showLeftHandPanel: false,
        showAnnotationTools: false,
        enableLinearization: true
      }));
      resolve();
    });
  };
  _proto.previewFileWithBlob = function previewFileWithBlob(config, fileData, viewerConfig) {
    var _this3 = this;
    var url = fileData.url,
      fileName = fileData.fileName;
    return new Promise(function (resolve, reject) {
      fetch(new Request(url)).then(function (response) {
        return response.blob();
      }).then(function (blob) {
        _this3.adobeDCView = new _this3.window.AdobeDC.View(config);
        _this3.adobeDCView.previewFile({
          content: {
            promise: Promise.resolve(blob.arrayBuffer())
          },
          metaData: {
            fileName: fileName
          }
        }, __spreadProps(__spreadValues({}, viewerConfig), {
          showLeftHandPanel: false,
          showAnnotationTools: false
          // enableLinearization: true,
        }));

        resolve();
      })["catch"](reject);
    });
  };
  _proto.registerEventsHandler = function registerEventsHandler(eventsHandler) {
    this.adobeDCView.registerCallback(this.window.AdobeDC.View.Enum.CallbackType.EVENT_LISTENER, function (event) {
      eventsHandler(event.type);
    }, {});
  };
  return PDFViewSDKClient;
}();

var PDF_STATUS = /* @__PURE__ */function (PDF_STATUS2) {
  PDF_STATUS2[PDF_STATUS2["NONE"] = 0] = "NONE";
  PDF_STATUS2[PDF_STATUS2["PENDING"] = 1] = "PENDING";
  PDF_STATUS2[PDF_STATUS2["LOADING_FILE"] = 2] = "LOADING_FILE";
  PDF_STATUS2[PDF_STATUS2["READY"] = 3] = "READY";
  PDF_STATUS2[PDF_STATUS2["ERROR"] = 4] = "ERROR";
  return PDF_STATUS2;
}(PDF_STATUS || {});
var PDF_OPTIONS_TO_EMBED_PROPERTIES = {
  FULL: "",
  MINI: "SIZED_CONTAINER"
};
var PDF_OPTIONS = {
  FULL: "FULL",
  MINI: "MINI",
  NONE: "NONE"
};
var RICOS_LOCALE_TO_ADOBE = {
  da: "da-DK",
  nl: "nl-NL",
  en: "en-US",
  fi: "fi-FI",
  fr: "fr-FR",
  de: "de-DE",
  it: "it-IT",
  ja: "ja-JP",
  no: "nb-NO",
  pt: "pt-BR",
  es: "es-ES",
  sv: "sv-SE",
  cs: "cs-CZ",
  ko: "ko-KR",
  pl: "pl-PL",
  ru: "ru-RU",
  tr: "tr-TR",
  zh: "zg-CN"
};
var ADOBE_EVENT_TO_PDF_STATUS = {
  APP_RENDERING_DONE: 3 /* READY */,
  PDF_VIEWER_OPEN: 2 /* LOADING_FILE */,
  APP_RENDERING_FAILED: 4 /* ERROR */
};

var styles = {"iframe":"AuGHK","not_ready":"vSLOy","pdf_viewer":"QEyvx"};

function setAdobeSDKScript(scope) {
  var element = scope.document.createElement("script");
  element.setAttribute("id", "ricos-adobe-pdf-view-sdk");
  element.setAttribute("src", "https://documentcloud.adobe.com/view-sdk/main.js");
  scope.document.getElementsByTagName("body")[0].appendChild(element);
}
function PDFViewer(props) {
  var _classnames;
  var status = props.status,
    setStatus = props.setStatus,
    fileData = props.fileData,
    _props$config = props.config,
    clientId = _props$config.clientId,
    _props$config$locale = _props$config.locale,
    locale = _props$config$locale === void 0 ? "en" : _props$config$locale,
    pdfSettings = props.pdfSettings;
  var _useState = useState(void 0),
    divId = _useState[0],
    setDivId = _useState[1];
  if (!divId) {
    setDivId("ricos-pdf-viewer-" + Math.floor(Math.random() * 1e4));
  }
  var _ref = pdfSettings || {},
    _ref$viewMode = _ref.viewMode,
    viewMode = _ref$viewMode === void 0 ? PDF_OPTIONS.NONE : _ref$viewMode,
    _ref$disableDownload = _ref.disableDownload,
    disableDownload = _ref$disableDownload === void 0 ? false : _ref$disableDownload,
    _ref$disablePrint = _ref.disablePrint,
    disablePrint = _ref$disablePrint === void 0 ? false : _ref$disablePrint;
  var handleError = function handleError(error) {
    console.log(error);
    setStatus(PDF_STATUS.ERROR);
  };
  var eventsHandler = function eventsHandler(event) {
    var newStatus = ADOBE_EVENT_TO_PDF_STATUS[event];
    if (newStatus && newStatus !== status) {
      setStatus(newStatus);
    }
  };
  useEffect(function () {
    var pdfStatus = viewMode !== PDF_OPTIONS.NONE ? PDF_STATUS.PENDING : PDF_STATUS.NONE;
    status !== pdfStatus && setStatus(pdfStatus);
  }, [props.pdfSettings.viewMode, props.pdfSettings.disableDownload, props.pdfSettings.disablePrint]);
  useEffect(function () {
    if (!window.document.getElementById("ricos-adobe-pdf-view-sdk")) {
      setAdobeSDKScript(window);
    } else if (status === PDF_STATUS.PENDING) {
      var SDKClient = new PDFViewSDKClient(window);
      SDKClient.ready().then(function () {
        var viewerConfig = {
          embedMode: PDF_OPTIONS_TO_EMBED_PROPERTIES[viewMode],
          showDownloadPDF: !disableDownload,
          showPrintPDF: !disablePrint
        };
        var properties = {
          clientId: clientId,
          divId: divId,
          locale: RICOS_LOCALE_TO_ADOBE[locale]
        };
        SDKClient.previewFileWithURL(properties, fileData, viewerConfig).then(function () {
          SDKClient.registerEventsHandler(eventsHandler);
        })["catch"](handleError);
      })["catch"](handleError);
    }
  });
  var style = classnames(styles.pdf_viewer, (_classnames = {}, _classnames[styles.not_ready] = status !== PDF_STATUS.READY, _classnames));
  return /* @__PURE__ */React.createElement("div", {
    id: divId,
    className: style
  });
}

var __defProp = Object.defineProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var getNameWithoutType = function getNameWithoutType(fileName) {
  if (!fileName || !fileName.includes(".")) {
    return fileName;
  }
  var s = fileName.split(".");
  return s.slice(0, s.length - 1).join(".");
};
var resizeWidths = {
  first: 320,
  second: 140,
  third: 100
};
var FileUploadViewer = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(FileUploadViewer, _PureComponent);
  function FileUploadViewer(props) {
    var _this;
    _this = _PureComponent.call(this, props) || this;
    __publicField(_assertThisInitialized(_this), "isInResizeRange", function (resizeWidth) {
      var _a, _b;
      return ((_b = (_a = _this.fileUploadViewerRef) == null ? void 0 : _a.current) == null ? void 0 : _b.clientWidth) < resizeWidth;
    });
    __publicField(_assertThisInitialized(_this), "switchReadyIcon", function () {
      return _this.setState({
        showReadyIcon: true
      }, function () {
        return setTimeout(function () {
          return _this.setState({
            showReadyIcon: false
          });
        }, 2e3);
      });
    });
    __publicField(_assertThisInitialized(_this), "renderContainerWithoutLink", function () {
      var _classnames;
      var _this$props = _this.props,
        tempDataPlaceHolder = _this$props.tempDataPlaceHolder,
        componentData = _this$props.componentData;
      var _ref = tempDataPlaceHolder ? tempDataPlaceHolder : componentData,
        name = _ref.name,
        type = _ref.type;
      return /* @__PURE__ */React.createElement("div", {
        className: classnames(_this.styles.file_upload_link, (_classnames = {}, _classnames[_this.styles.width_three] = _this.isInResizeRange(resizeWidths.third), _classnames))
      }, _this.renderViewerBody({
        name: name,
        type: type
      }));
    });
    __publicField(_assertThisInitialized(_this), "renderIcon", function (Icon) {
      var _this$props2 = _this.props,
        isLoading = _this$props2.isLoading,
        isMobile = _this$props2.isMobile,
        error = _this$props2.componentData.error;
      var _this$state = _this.state,
        showReadyIcon = _this$state.showReadyIcon,
        resolvingUrl = _this$state.resolvingUrl,
        pdfStatus = _this$state.pdfStatus;
      var showLoader = isLoading || resolvingUrl || pdfStatus === PDF_STATUS.LOADING_FILE;
      var showFileIcon = !showLoader && !showReadyIcon && isMobile || !isMobile && Icon;
      if (showFileIcon) {
        var _classnames2;
        return /* @__PURE__ */React.createElement(Icon, {
          styles: _this.styles,
          className: classnames(_this.styles.file_upload_type_icon, (_classnames2 = {}, _classnames2[_this.styles.width_three] = _this.isInResizeRange(resizeWidths.third), _classnames2))
        });
      } else {
        return /* @__PURE__ */React.createElement("div", {
          className: isMobile ? _this.styles.mobile_status_icon : _this.styles.file_upload_state
        }, error ? /* @__PURE__ */React.createElement(ErrorIcon, null) : showLoader ? /* @__PURE__ */React.createElement(LoaderIcon, {
          className: _this.styles.file_loader_icon
        }) : showReadyIcon ? /* @__PURE__ */React.createElement(ReadyIcon, null) : !_this.isInResizeRange(resizeWidths.first) && /* @__PURE__ */React.createElement(DownloadIcon, null));
      }
    });
    __publicField(_assertThisInitialized(_this), "sizeToString", function (size) {
      return size < 1e3 ? size + "B" : size < 1e6 ? Math.round(size / 1e3) + "KB" : (size / 1e6).toFixed(2) + "MB";
    });
    __publicField(_assertThisInitialized(_this), "getExperiments", function () {
      return _this.props.experiments || _this.context.experiments;
    });
    __publicField(_assertThisInitialized(_this), "onFileClick", function () {
      var _a, _b;
      return (_b = (_a = _this.props.helpers).onViewerAction) == null ? void 0 : _b.call(_a, FILE_UPLOAD_TYPE, "Click");
    });
    __publicField(_assertThisInitialized(_this), "onPDFStatusChange", function (status) {
      return _this.setState({
        pdfStatus: status
      });
    });
    var componentData = props.componentData,
      _props$componentData = props.componentData,
      type = _props$componentData.type,
      pdfSettings = _props$componentData.pdfSettings,
      adobeAPIKey = props.settings.adobeAPIKey;
    var viewMode = (pdfSettings == null ? void 0 : pdfSettings.viewMode) || PDF_OPTIONS.NONE;
    validate(componentData, pluginFileUploadSchema);
    _this.downloaderRef = /*#__PURE__*/React.createRef();
    _this.fileUploadViewerRef = /*#__PURE__*/React.createRef();
    var pdfStatus = type === "pdf" && viewMode !== PDF_OPTIONS.NONE && adobeAPIKey ? PDF_STATUS.PENDING : PDF_STATUS.NONE;
    _this.state = {
      resolvedFileUrl: null,
      resolvingUrl: false,
      currentWidth: 0,
      pdfStatus: pdfStatus
    };
    return _this;
  }
  var _proto = FileUploadViewer.prototype;
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextComponentData = nextProps.componentData;
      nextProps.settings.adobeAPIKey;
    var componentData = this.props.componentData;
    if (!isEqual(nextComponentData, componentData)) {
      validate(nextComponentData, pluginFileUploadSchema);
    }
    if (!nextProps.isLoading && this.props.isLoading) {
      this.switchReadyIcon();
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    if (window == null ? void 0 : window.ResizeObserver) {
      this.resizer = new ResizeObserver(debounce(function (entries) {
        _this2.setState({
          currentWidth: Math.round(entries[0].contentRect.width)
        });
      }, 60));
      this.resizer.observe(this.fileUploadViewerRef.current);
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var _a;
    (_a = this.resizeObserver) == null ? void 0 : _a.unobserve(this.fileUploadViewerRef.current);
  };
  _proto.getFileInfoString = function getFileInfoString(type) {
    var _this$props3 = this.props,
      componentData = _this$props3.componentData,
      t = _this$props3.t,
      isLoading = _this$props3.isLoading,
      tempDataPlaceHolder = _this$props3.tempDataPlaceHolder;
    var resolvingUrl = this.state.resolvingUrl;
    if (componentData.error) {
      return {
        infoString: t("UploadFile_Error_Generic_Item"),
        infoStyle: this.styles.file_upload_text_error
      };
    }
    var translationKey = isLoading || resolvingUrl ? "UploadFile_Viewer_Loader" : "UploadFile_Viewer_Download";
    var infoString = t(translationKey, {
      fileType: type == null ? void 0 : type.toUpperCase()
    });
    var size = componentData.size || (tempDataPlaceHolder == null ? void 0 : tempDataPlaceHolder.size);
    if (size) {
      infoString = infoString + " \u2022 " + this.sizeToString(size);
    }
    return {
      infoString: infoString,
      infoStyle: this.styles.file_upload_type
    };
  };
  _proto.renderViewerBody = function renderViewerBody(_ref2) {
    var _classnames3, _classnames4;
    var name = _ref2.name,
      type = _ref2.type;
    var isMobile = this.props.isMobile;
    var nameWithoutType = getNameWithoutType(name);
    var Icon = getIcon(type);
    var _this$getFileInfoStri = this.getFileInfoString(type),
      infoString = _this$getFileInfoStri.infoString,
      infoStyle = _this$getFileInfoStri.infoStyle;
    return /* @__PURE__ */React.createElement(React.Fragment, null, this.renderIcon(Icon), !isMobile && this.renderIcon(), !this.isInResizeRange(resizeWidths.third) && /* @__PURE__ */React.createElement("div", {
      className: classnames(this.styles.file_upload_text_container, (_classnames3 = {}, _classnames3[this.styles.width_two] = this.isInResizeRange(resizeWidths.second), _classnames3))
    }, /* @__PURE__ */React.createElement("div", {
      className: this.styles.file_upload_name_container
    }, !this.isInResizeRange(resizeWidths.second) && /* @__PURE__ */React.createElement("div", {
      className: this.styles.file_upload_name
    }, nameWithoutType), type && /* @__PURE__ */React.createElement("div", {
      className: classnames(this.styles.file_upload_extension, (_classnames4 = {}, _classnames4[this.styles.width_one] = this.isInResizeRange(resizeWidths.first), _classnames4))
    }, "." + type)), /* @__PURE__ */React.createElement("div", {
      className: infoStyle
    }, infoString)));
  };
  _proto.renderViewer = function renderViewer(fileUrl) {
    var _classnames5;
    var _this$props4 = this.props,
      _this$props4$componen = _this$props4.componentData,
      name = _this$props4$componen.name,
      type = _this$props4$componen.type,
      error = _this$props4$componen.error,
      tempDataPlaceHolder = _this$props4.tempDataPlaceHolder;
    var downloadTarget = this.props.settings.downloadTarget;
    if (error || tempDataPlaceHolder) {
      return this.renderContainerWithoutLink();
    }
    return /* @__PURE__ */React.createElement("a", {
      href: fileUrl,
      target: downloadTarget,
      className: classnames(this.styles.file_upload_link, (_classnames5 = {}, _classnames5[this.styles.width_three] = this.isInResizeRange(resizeWidths.third), _classnames5)),
      onClick: this.onFileClick
    }, this.renderViewerBody({
      name: name,
      type: type
    }));
  };
  _proto.renderFileUrlResolver = function renderFileUrlResolver() {
    var _this3 = this,
      _classnames6;
    var _this$props5 = this.props,
      componentData = _this$props5.componentData,
      resolveFileUrl = _this$props5.settings.resolveFileUrl;
    var name = componentData.name,
      type = componentData.type,
      error = componentData.error;
    if (error) {
      return this.renderContainerWithoutLink();
    }
    var fileUrlResolver = function fileUrlResolver() {
      var resolvingUrl = _this3.state.resolvingUrl;
      if (!resolvingUrl) {
        _this3.setState({
          resolvingUrl: true
        });
        resolveFileUrl(componentData).then(function (resolvedFileUrl) {
          _this3.setState({
            resolvedFileUrl: resolvedFileUrl,
            resolvingUrl: false
          }, _this3.switchReadyIcon);
          if (_this3.downloaderRef.current) {
            _this3.downloaderRef.current.href = resolvedFileUrl;
            _this3.downloaderRef.current.download = name;
            _this3.downloaderRef.current.click();
          }
        });
      }
    };
    var resolveIfEnter = function resolveIfEnter(ev) {
      var enterEvent = 13;
      if (ev.which === enterEvent) {
        fileUrlResolver();
      }
    };
    return /* @__PURE__ */React.createElement("div", {
      onClick: fileUrlResolver,
      onKeyDown: resolveIfEnter,
      role: "button",
      tabIndex: 0,
      className: classnames(this.styles.file_upload_link, (_classnames6 = {}, _classnames6[this.styles.width_three] = this.isInResizeRange(resizeWidths.third), _classnames6))
    }, this.renderViewerBody({
      name: name,
      type: type
    }));
  };
  _proto.renderAutoDownloadLinkRef = function renderAutoDownloadLinkRef() {
    var _this$props$settings = this.props.settings,
      withFileUrlResolver = _this$props$settings.resolveFileUrl,
      downloadTarget = _this$props$settings.downloadTarget;
    if (!withFileUrlResolver) {
      return null;
    }
    var target = downloadTarget || "_blank";
    this.getExperiments();
    return /* @__PURE__ */React.createElement("a", {
      href: "#0",
      ref: this.downloaderRef,
      style: {
        display: "none"
      },
      target: target
    }, /* @__PURE__ */React.createElement(React.Fragment, null));
  };
  _proto.render = function render() {
    var _a;
    var _this$props6 = this.props,
      componentData = _this$props6.componentData,
      _this$props6$componen = _this$props6.componentData.pdfSettings,
      pdfSettings = _this$props6$componen === void 0 ? {} : _this$props6$componen,
      theme = _this$props6.theme,
      setComponentUrl = _this$props6.setComponentUrl,
      tempDataPlaceHolder = _this$props6.tempDataPlaceHolder,
      adobeAPIKey = _this$props6.settings.adobeAPIKey,
      locale = _this$props6.locale;
      _this$props6.iframeSandboxDomain;
    var pdfStatus = this.state.pdfStatus;
    this.styles = this.styles || mergeStyles({
      styles: fileStyles,
      theme: theme
    });
    var fileUrl = componentData.url || this.state.resolvedFileUrl;
    setComponentUrl == null ? void 0 : setComponentUrl(fileUrl);
    var viewer = fileUrl || tempDataPlaceHolder ? this.renderViewer(fileUrl) : this.renderFileUrlResolver();
    var dataHook = "fileUploadViewer";
    var shouldRenderPDFViewer = ((_a = this.getExperiments().enableFilePluginPDFViewer) == null ? void 0 : _a.enabled) && typeof window !== "undefined" && fileUrl && ![PDF_STATUS.ERROR].includes(pdfStatus);
    var style = classnames(this.styles.file_upload_container, componentData.error && this.styles.file_upload_error_container);
    return /* @__PURE__ */React.createElement(Tooltip, {
      content: this.isInResizeRange(resizeWidths.first) && componentData.name,
      tooltipOffset: {
        y: 25
      }
    }, shouldRenderPDFViewer ? /* @__PURE__ */React.createElement("div", {
      "data-hook": dataHook,
      ref: this.fileUploadViewerRef
    }, /* @__PURE__ */React.createElement(PDFViewer, {
      status: pdfStatus,
      fileData: {
        url: fileUrl,
        fileName: componentData.name
      },
      setStatus: this.onPDFStatusChange,
      pdfSettings: pdfSettings,
      config: {
        clientId: adobeAPIKey,
        locale: locale
      }
    }), ![PDF_STATUS.READY].includes(pdfStatus) && /* @__PURE__ */React.createElement("div", {
      className: style
    }, viewer)) : /* @__PURE__ */React.createElement("div", {
      "data-hook": dataHook,
      ref: this.fileUploadViewerRef,
      className: style
    }, viewer, this.renderAutoDownloadLinkRef()));
  };
  return FileUploadViewer;
}(PureComponent);
__publicField(FileUploadViewer, "contextType", GlobalContext);
FileUploadViewer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  componentData: PropTypes.object.isRequired,
  tempDataPlaceHolder: PropTypes.object,
  settings: PropTypes.object,
  theme: PropTypes.object.isRequired,
  setComponentUrl: PropTypes.func,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
  helpers: PropTypes.object,
  locale: PropTypes.string,
  iframeSandboxDomain: PropTypes.string,
  experiments: PropTypes.object
};
FileUploadViewer.defaultProps = {
  isLoading: false,
  settings: {}
};

export { FileUploadViewer as default };

import 'wix-rich-content-plugin-file-upload/dist/loadable/viewer/es/styles.viewer.min.global.css'